import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import { translations } from '../components/LanguageSelector/translations';

const ProductPaymentCancelledPage: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const t = translations[language] || translations.en;

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          {/* Cancelled Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-6">
            <svg className="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>

          {/* Cancelled Message */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {t.productPayment.cancelledTitle || 'Payment Cancelled'}
          </h1>
          
          <p className="text-lg text-gray-600 mb-6">
            {t.productPayment.cancelledMessage || 'Your payment was cancelled. No charges have been made to your account.'}
          </p>

          {/* Information */}
          <div className="bg-yellow-50 rounded-lg p-6 mb-8">
            <h3 className="text-lg font-semibold text-yellow-900 mb-3">
              {t.productPayment.whatHappened || 'What happened?'}
            </h3>
            <ul className="text-left text-yellow-800 space-y-2">
              <li className="flex items-start">
                <span className="text-yellow-600 mr-2">•</span>
                {t.productPayment.noCharge || 'No charges were made to your payment method'}
              </li>
              <li className="flex items-start">
                <span className="text-yellow-600 mr-2">•</span>
                {t.productPayment.cartPreserved || 'Your cart items are still available'}
              </li>
              <li className="flex items-start">
                <span className="text-yellow-600 mr-2">•</span>
                {t.productPayment.tryAgain || 'You can try the payment again anytime'}
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/cart')}
              className="bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700 transition-colors font-medium"
            >
              {t.productPayment.returnToCart || 'Return to Cart'}
            </button>
            
            <button
              onClick={() => navigate('/products')}
              className="bg-gray-600 text-white px-6 py-3 rounded-md hover:bg-gray-700 transition-colors font-medium"
            >
              {t.productPayment.continueShopping || 'Continue Shopping'}
            </button>
          </div>

          {/* Help Section */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600 mb-2">
              {t.productPayment.needHelp || 'Need help with your payment?'}
            </p>
            <p className="text-sm text-gray-600">
              {t.productPayment.contactUs || 'Contact us at'} {' '}
              <a 
                href="mailto:info@ladolcevitareis.nl" 
                className="text-green-600 hover:text-green-700 font-medium"
              >
                info@ladolcevitareis.nl
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPaymentCancelledPage;
